import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../services/sysadmin.service";
import { RolesToChangeModel } from "../RolesToChangeModel";

@Component({
	selector: "app-user-group-add-roles",
	templateUrl: "./user-group-add-roles.component.html",
	styleUrls: ["./user-group-add-roles.component.css"],
})
export class UserGroupAddRolesComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.UserGroupID = this.dialogConfig.data.UserGroupID;
		//Get Data from DB
		this.loadRoleList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	UserGroupID: any;
	UserLevelID: any = 0;
	SchoolID: any = 0;
	lstRoles: any = [];
	SelectedRoles: any = [];
	OriginalRoles: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [{ field: "RoleDesc", header: "Role" }];

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadRoleList() {
		this.loading = true;

		var result = this.sysAdminService.loadRoleList(this.UserLevelID, this.SchoolID, 1);
		result.subscribe(
			(response) => {
				this.lstRoles = response;
				this.UpdateSelected();
				this.loading = false;
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedRoles = this.dialogConfig.data.SelectedRoles;
		this.OriginalRoles = this.dialogConfig.data.SelectedRoles;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		//Get rid of roles that are already attached to the User Group
		var RolesToAdd = this.SelectedRoles.filter((role) => this.OriginalRoles.indexOf(role) == -1);

		//Create list of strings
		var lstRoleID: string[] = [];

		for (var i = 0; i < RolesToAdd.length; i++) {
			var next = String(RolesToAdd[i].RoleId);
			lstRoleID = [...lstRoleID, next];
		}

		//Create Query Data
		let data: RolesToChangeModel = {
			UserGroupID: this.UserGroupID,
			RoleIDs: lstRoleID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupAddRoles(data);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Roles were added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add roles to the User Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
